export default "__VITE_ASSET__5dd27f81__"